import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { FormRelease, Heading, Tag } from '../../../../core';
export var FormReleaseApiMapper = /*#__PURE__*/function () {
  function FormReleaseApiMapper(sectionSummaryApiMapper) {
    _classCallCheck(this, FormReleaseApiMapper);

    this.sectionSummaryApiMapper = sectionSummaryApiMapper;
  }

  _createClass(FormReleaseApiMapper, [{
    key: "toDomain",
    value: function toDomain(formReleaseDto) {
      var _this = this;

      var props = {
        id: formReleaseDto.id,
        coverImage: formReleaseDto.coverImage,
        description: formReleaseDto.description,
        sections: formReleaseDto.sections.map(function (section) {
          return _this.sectionSummaryApiMapper.toDomain(formReleaseDto.id, section);
        }),
        version: formReleaseDto.version,
        title: formReleaseDto.title
      };

      if (formReleaseDto.headings) {
        props.headings = formReleaseDto.headings.map(function (heading) {
          return Heading.create({
            title: heading.title,
            description: heading.description,
            formId: formReleaseDto.id,
            sectionId: heading.sectionId,
            nextQuestionId: heading.nextQuestionId,
            previousHeadingId: heading.previousHeadingId,
            nextHeadingId: heading.nextHeadingId,
            previousQuestionId: heading.previousQuestionId
          }, heading.id.toString()).getValue();
        });
      }

      if (formReleaseDto.tags) {
        props.tags = formReleaseDto.tags.map(function (t) {
          return Tag.create({
            id: t.id,
            key: t.key
          }).getValue();
        });
      }

      return FormRelease.create(props).getValue();
    }
  }]);

  return FormReleaseApiMapper;
}();